import type { NavigationItem } from '../models';

export const findCurrentSubpagePath = (navItemArray: NavigationItem[]) => {
  const navPathInner: NavigationItem[] = [];

  navItemArray.forEach((navItem) => {
    if (navItem.IsCurrent) {
      navPathInner.push(navItem);

      return;
    }

    if (navItem.Children.length) {
      const tmp = [...findCurrentSubpagePath(navItem.Children)];
      if (tmp.length) {
        navPathInner.push(navItem, ...tmp);
      }
    }
  });

  return navPathInner;
};
